/* eslint-disable react/no-this-in-sfc */
import useSelfie from "lib/hooks/useSelfie";
import type { ReactElement } from "react";

interface OnlyPremiumRenderProps {
  children: ReactElement;
}
export default function OnlyPremiumRender({ children }: OnlyPremiumRenderProps) {
  const viewer = useSelfie();
  // eslint-disable-next-line react/jsx-no-useless-fragment, react/jsx-fragments
  return viewer?.isPremium ? children : null;
}
